import { parse as parseQueryString } from 'querystring';
import { call } from 'redux-saga/effects';
import { writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { CORPORATE_PARTNER_STORAGE_KEY } from 'constants/corporate';
import { parseCorporatePartnerPath } from 'helpers/corporate';

export function* corporateOnEnterSaga(client, nextState) {
  const corporatePartner = parseCorporatePartnerPath(nextState.params.corporatePartner);
  const query = parseQueryString((nextState.location.search || '').substr(1));
  const corporatePartnerObj = {
    partner: corporatePartner,
    token: query.token ? query.token : 'unknown',
    initial_url: nextState.location.pathname,
    created: new Date(),
  };

  yield call(writeLocalStorage, CORPORATE_PARTNER_STORAGE_KEY, corporatePartnerObj);
}
